import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export async function courierGetActiveDelivery() {
  const headers = await getAuthHeaders();
  const url = `${API_BASE_URL}/orders/courier/active`;
  const response = await fetch(url, { method: 'GET', headers });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}

export async function courierAdvanceActiveDelivery(action) {
  const headers = await getAuthHeaders({ 'Content-Type': 'application/json' });
  const url = `${API_BASE_URL}/orders/courier/active/advance`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify({ action }),
  });
  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return await response.json();
}

export async function courierPushLiveLocation(orderCode, location) {
  const headers = await getAuthHeaders({ 'Content-Type': 'application/json' });
  const url = `${API_BASE_URL}/orders/${encodeURIComponent(orderCode)}/courier/live-location`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(location),
  });

  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || `HTTP ${response.status}`);
    err.status = response.status;
    throw err;
  }

  return await response.json();
}
